class CartProgress extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.dataset.giftVariantId;
    this.variantIdTwo = this.dataset.giftTwoVariantId;
    this.thresholdOne = parseFloat(this.dataset.threshold);
    this.thresholdTwo = parseFloat(this.dataset.thresholdTwo);
  }

  connectedCallback() {
    this.addButton = this.querySelector('.single-add-to-cart-button--text');
    if (this.addButton) {
      this.addButton.removeEventListener('click', this._freeGiftAddToCart);
      this.addButton.addEventListener('click', (event) => this._freeGiftAddToCart(event, this.addButton));
    }

    this.addEventListener('change', (event) => {
      const variantSelector = event.target.classList.contains('cart-progress__free-product--variant-select') ?
        event.target :
        event.target.closest('.cart-progress__free-product--variant-select');

      if (variantSelector) {
        this._updateVariant(event, variantSelector);
      }
    });
  }
  
  async _updateElement() {
    try {
      const res = await fetch('/?section_id=cart-drawer');
      const section = await res.text();
      const cartDrawer = document.createElement('div');
      cartDrawer.innerHTML = section;

      const updatedMessage = cartDrawer.querySelector('[data-cart-message]');
      const currentMessages = document.querySelectorAll('[data-cart-message]');
      
      if (currentMessages.length && updatedMessage) {
        currentMessages.forEach((message) => {
          message.innerHTML = updatedMessage.innerHTML;
        });
      }

      const updatedBar = cartDrawer.querySelector('[data-bar-progress]');
      const currentBar = document.querySelector('[data-bar-progress]');
      if (currentBar && updatedBar) {
        const progressWidth = updatedBar.getAttribute('style');
        if(progressWidth) {
          currentBar.setAttribute('style', progressWidth)
        }
      }
      
      const updatedProducts = cartDrawer.querySelector('[data-gift-products]');
      const currentProducts = document.querySelector('[data-gift-products]');
      if (currentProducts && updatedProducts) {
        currentProducts.innerHTML = updatedProducts.innerHTML;
      }

      const updatedTimerImage = cartDrawer.querySelector('[data-gift-timer-image]');
      const currentTimerImage = document.querySelector('[data-gift-timer-image]');
      if(updatedTimerImage && currentTimerImage) {
        currentTimerImage.innerHTML = updatedTimerImage.innerHTML;
      }

      const updatedTimer = cartDrawer.querySelector('[data-cart-gift-timer]');
      const currentTimer = document.querySelector('[data-cart-gift-timer]');
      if(updatedTimer && currentTimer) {
        const updatedClasses = updatedTimer.classList;
        currentTimer.setAttribute('class', updatedClasses)
      }
      
      
    } catch (error) {
      console.error(error);
    }
  }

  _updateVariant(event, selector) {
    const parent = event.target.closest('.cart-progress__free-product');
    const id = event.target.value;
    const addToCartButton = parent.querySelector('.cart-progress__free-product--add');
    const images = parent.querySelectorAll('.free-product__image-wrapper img');
    const variantImage = parent.querySelector(`#variant-image--${id}`);

    images.forEach(img => img.style.opacity = 0);
    variantImage.style.opacity = 1;
    addToCartButton.removeAttribute('disabled')
  }

  async _getCart() {
    try {
      const response = await fetch(`${theme.routes.cart_url}.js`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const data = await response.json();
      return data; // Return the parsed JSON cart object
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null; // Return null in case of an error
    }
}
  
  async testThreshold() {
    this.cart = await this._getCart();
    this.cartTotal = this.cart.total_price;
    this.giftInCart = this.cart.items.find((item) => item.variant_id == this.variantId);
    this.giftInCartTwo = this.cart.items.find((item) => item.variant_id == this.variantIdTwo);

    let updates = theme.oakreativ.giftCombineType === 'combine' 
          ? this.setUpdatesCombine() 
          : this.setUpdatesReplace();
    
    this.autoUpdateCart(updates);
  }

 setUpdatesCombine() {
    let updates = {};
    // Handle gift at first threshold
    if(this.variantId) {
      if (this.cartTotal >= this.thresholdOne) {
        if (!this.giftInCart && theme.oakreativ.giftType == 'automatic') {
          updates[this.variantId] = 1; // Add the gift if not already in the cart
        }
      } else if (this.giftInCart) {
        updates[this.variantId] = 0; // Remove the gift if below the threshold
      }
    }
  
    // Handle gift at second threshold
    if(this.variantIdTwo) {
      if (this.cartTotal >= this.thresholdTwo) {
      if (!this.giftInCartTwo && theme.oakreativ.giftType == 'automatic') {
          updates[this.variantIdTwo] = 1; // Add the second gift if not already in the cart
        }
      } else if (this.giftInCartTwo) {
        updates[this.variantIdTwo] = 0; // Remove the gift if below the threshold
      }
    }

    return updates;
  }
    
  setUpdatesReplace() {
    let updates = {};

    // Handle higher threshold (replace lower gift if applicable)
    if (this.cartTotal >= this.thresholdTwo) {
      if (!this.giftInCartTwo && this.variantIdTwo && theme.oakreativ.giftType == 'automatic') {
        updates[this.variantIdTwo] = 1; // Ensure second gift is in the cart
      }
      if (this.giftInCart && this.variantId) {
        updates[this.variantId] = 0; // Remove the first gift
      }
    } else if (this.cartTotal >= this.thresholdOne && this.cartTotal < this.thresholdTwo) {
      if (!this.giftInCart && this.variantId && theme.oakreativ.giftType == 'automatic') {
          updates[this.variantId] = 1; // Ensure first gift is in the cart
      }
      if (this.giftInCartTwo && this.variantIdTwo) {
          updates[this.variantIdTwo] = 0; // Remove the second gift
      }
    } else {
      // If below both thresholds, remove any gifts
      if (this.giftInCart && this.variantId) {
        updates[this.variantId] = 0;
      }
      if (this.giftInCartTwo && this.variantIdTwo) {
          updates[this.variantIdTwo] = 0;
      }
    }

    return updates;
  }

  autoUpdateCart(updates) {
    if (Object.keys(updates).length !== 0) {
      const formData = {
        updates: updates,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      };
    
      fetch(`/cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then((response) => response.json())
      .then((response) => {
        console.log(response)
        this.renderContents(response);
        dispatchCustomEvent('cart:item-added', {
          product: response.hasOwnProperty('items') ? response.items[0] : response
        });
      })
      .catch((e) => {
        console.error(e);
      });
    }
  }
  
  _freeGiftAddToCart(event, button) {
    event.preventDefault();
    button.setAttribute('disabled', 'disabled');
  
    const parent = event.target.closest('[data-gift-form]');
    const input = parent.querySelector('[name="variant"]');
    const variantId = input.value;
    const giftNumber = parent.dataset.gift;
  
    const giftInCart = document.querySelector('[data-gift-item]');
    let formData;
  
    if (giftInCart) {
      const existingVariantId = giftInCart.dataset.giftId;
  
      formData = {
        updates: {
          [variantId]: 1,
          [existingVariantId]: 0
        },
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      };
    } else {
      formData = {
        updates: {
          [variantId]: 1
        },
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      };
    }
  
    if (!button.classList.contains('loading')) {
      button.setAttribute('aria-disabled', true);
      button.classList.add('loading');
    }
  
    fetch(`/cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((response) => response.json())
      .then((response) => {
        this.renderContents(response);
        dispatchCustomEvent('cart:item-added', {
          product: response.hasOwnProperty('items') ? response.items[0] : response
        });
        // Call _updateElement only after the fetch request succeeds
        this._updateElement();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        button.innerText = "Added";
      });
  }

  getSectionsToRender() {
    return [{
      id: 'Cart',
      section: 'main-cart',
      selector: '.thb-cart-form'
    },
    {
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '#cart-drawer-items'
    },
    {
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '#cart-drawer-footer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      if (!document.getElementById(section.id)) {
        return;
      }
      const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

      if (typeof CartDrawer !== 'undefined') {
        new CartDrawer();
      }
      if (typeof Cart !== 'undefined') {
        new Cart().renderContents(parsedState);
      }
    }));
  }
  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

};
window.customElements.define('cart-progress', CartProgress);

function progressDebounce(fn, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), delay);
  };
}

const debouncedTestThreshold = progressDebounce((cartProgress, cart) => {
  cartProgress.testThreshold(cart);
}, 500);

document.addEventListener('line-item:change:end', (event) => {
  const cart = event.detail.cart;
  const cartProgress = document.querySelector('cart-progress');
  if (cartProgress) {
    debouncedTestThreshold(cartProgress, cart);
  }
});

document.addEventListener('cart:item-added', () => {
  const cartProgress = document.querySelector('cart-progress');
  if (cartProgress) {
    cartProgress.testThreshold();
  }
});
